export const FINALIZE = "Finalizar";
